<template>
  <div class="multiple-toggle">
    <div class="label" v-for="check of (list||[])" :key="check.field" @click="toggle(check)">
      <input type="checkbox" :value="check.field" :checked="isChecked(check)">
      <span class="checkmark">{{ check.label}}</span></div>
  </div>
</template>
<script>

import {reactive, ref} from "@vue/composition-api";

export default {
  name: "MultiToggleSwitch",
  props: {
    list: Array,
    onChange: Function,
    selected: String | Boolean,
  },
  model: {
    event: "get",
  },
  setup(__props, { root }) {
    const checkbox = reactive({selected: ""});
    const toggle = (check) => {
      checkbox.selected = check.field;
      if (__props.onChange)__props.onChange(check)
      root.$emit("get", check);
    }
    const isChecked = (check) => {
      return checkbox.selected === check.field || (__props.selected || '').toString().toLowerCase() === check.field
    }
    return {checkbox, toggle, isChecked}
  }

}
</script>
<style lang="scss" scoped>
.multiple-toggle{
  display: flex;
  justify-content: space-between;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  border-radius: 4px;
  margin-top: -1px;
  .label {
    flex: 1;
    display: block;
    cursor: pointer;

    input {
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      top: -15px;
      padding: 10px;
      width:100%;
      height: 100%;
      background-color: #eee;
      cursor: pointer;

    }
    &:hover input ~ .checkmark {
      background-color: #ccc;
    }
    input:checked ~ .checkmark {
      background-color: #e00b5b;
      color: #fff;
    }
    input:checked ~ .checkmark:after {
      display: block;
    }
  }
}
</style> 
